import React, { useState, useEffect } from "react";
import {
    Form,
    Card,
    Spin
} from "antd";
import "../../../assets/styles/DatePicker.css";
import "../../../assets/styles/DatePicker.css";
import tabList from "./components/tabList.json";
import CustomButton from "../../../components/custom/CustomButton";
import { useNavigate } from "react-router-dom";
import FormLayoutBulkImport from "./FormLayoutBulkImport";



const TabLayoutBulkImport = ({ editing }) => {
    const navigate = useNavigate();
    const [activeTabKey, setActiveTabKey] = useState("branches");
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        // Simulate an API call or data fetching
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);


    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    function onCancel() { //This is Called in the Edit screen
        navigate("/dashboard", { replace: false });
    }



    const onSubmit = (values) => {
        console.log("Success:", values);
    };

    
    const [form] = Form.useForm();



    const contentListNoTitle = {};

    tabList.forEach(item => {
        contentListNoTitle[item.key] = <FormLayoutBulkImport formTitle = {item.label}/>;
    });


    return (
        <Spin spinning={loading}>
            <Card
                style={{
                    width: "100%",
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}
                tabList={tabList}
                activeTabKey={activeTabKey}
                onTabChange={onTabChange}
                tabProps={{
                    size: "middle",
                }}
                centered
            >
                {contentListNoTitle[activeTabKey]}
            </Card>
        </Spin>
    );
}

export default TabLayoutBulkImport;


